import React from "react";
import { Grid } from "@mui/material";
import FileUpload from "../../utils/FileUpload";
import bulk_spare_status from "../../assets/img/bulk_spare_status.png";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  uploadBulkSpareStatusService,
  DownloadErrorSpareMasterLogsService,
  DownloadSparesStatusTemplateService,
} from "../../services/BulkUploadServices";
import download from "downloadjs";
import useGlobalState from "../../Context";

const BulkSpareStatus = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }] = useGlobalState();
  const loggedInUserId = auth.ldapParam.userId;
  const loggedInName = auth.ldapParam.name;

  const downloadErrorLogs = async () => {
    try {
      setLoading(true);

      const payload = {
        requestType: 0,
        id: loggedInUserId,
      };

      const response = await DownloadErrorSpareMasterLogsService(payload);
      const content = response.headers["content-type"];
      download(response.data, "SpareStatusErrorLogs.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const downloadTemplate = async () => {
    try {
      setLoading(true);
      const response = await DownloadSparesStatusTemplateService();
      const content = response.headers["content-type"];
      download(response.data, "BulkSpareStatusTemplate.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const onFileChange = (event) => {
    if (
      event.target.files[0]?.type === "text/csv" ||
      event.target.files[0]?.type === "application/vnd.ms-excel" ||
      event.target.files[0]?.type === "application/vnd.msexcel" ||
      event.target.files[0]?.type === "application/csv" ||
      event.target.files[0]?.type === "text/comma-separated-values"
    ) {
      if (event.target.files[0].size >= 10485760) {
        // allowing only file less than 10mbs
        showNotification(
          "Error",
          "File too Big, please select a file less than 10mb"
        );
      } else {
        uploadFile(event.target.files[0]);
      }
    } else {
      showNotification("Error", "Invalid type selected, Please try again.");
    }
  };

  const uploadFile = async (file) => {
    const bulkSpareUploadRequest = {
      createdBy: loggedInUserId,
      createdByName: loggedInName,
      sendNotification: false,
    };

    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "bulkSpareUploadRequest",
      JSON.stringify(bulkSpareUploadRequest)
    );

    try {
      setLoading(true);
      const uploadResponse = await uploadBulkSpareStatusService(formData);
      if (uploadResponse.statusCode === 6) {
        showNotification("Success", uploadResponse.data.body.message, "success");
      } else {
        showNotification("Error", uploadResponse.data.body.message, "error");
      }
    } catch (err) {
      showNotification("Error", "Failed To submit File");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={0} sx={{ mt: 0, pb: 1, alignItems: "center" }}>
        <Grid item xs={3} sx={{ mt: "0" }}>
          <img src={bulk_spare_status} alt="Bulk Spare Status" width={45} />
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            color: "#757575",
            fontSize: "16px",
            fontWeight: "500",
            mt: "0",
          }}
        >
          <p>Bulk Spare Status</p>
        </Grid>

        <Grid item xs={5} sx={{ mt: "0", textAlign: "left" }}>
          <FileUpload
            onFileChange={onFileChange}
            userButton={true}
            showDownload={true}
            download={downloadTemplate}
            downloadErrors={downloadErrorLogs}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BulkSpareStatus;